import React from 'react';

/** Two-row pack title for headers: name (dark), phrase (pack accent). */
interface PackHeaderTitleProps {
  name: string;
  phrase: string;
}

export const PackHeaderTitle: React.FC<PackHeaderTitleProps> = ({ name, phrase }) => (
  <div className="pack-header-title">
    <h1 className="pack-header-title__name">{name}</h1>
    <span className="pack-header-title__phrase">{phrase}</span>
  </div>
);
